// Satu-satunya tempat membuat Supabase client. Semua repo modul memakai ini
// (tak ada modul yang membuat client sendiri) → mudah ganti/kelola koneksi.
import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import { config, isConfigured } from './config';

let client: SupabaseClient | null = null;

export function supabase(): SupabaseClient {
  if (!isConfigured()) {
    throw new Error(
      'Supabase belum dikonfigurasi. Isi VITE_SUPABASE_URL & VITE_SUPABASE_ANON_KEY di .env.local',
    );
  }
  if (!client) {
    client = createClient(config.supabaseUrl, config.supabaseAnonKey, {
      auth: {
        persistSession: true, autoRefreshToken: true,
        // Sesi disimpan PER-TAB (sessionStorage), bukan localStorage (Apo 19 Jul): localStorage
        // dipakai bersama semua tab satu browser → login Supplier di tab kedua MENIMPA sesi Owner
        // di tab pertama, lalu tab pertama memakai token peran lain (RLS menolak → layar error).
        // sessionStorage memberi tiap tab sesinya sendiri: Owner & Supplier bisa jalan berdampingan.
        // Konsekuensi wajar: tab ditutup = harus login lagi (tab baru ≠ sesi lama).
        storage: window.sessionStorage,
        storageKey: 'ifics-auth',
      },
    });
    // Sisa token dari versi sebelumnya (localStorage) tak lagi dipakai — buang agar tak ada
    // kredensial menganggur di penyimpanan browser.
    // Hanya kunci milik PROYEK INI — pola `sb-*-auth-token` dipakai semua proyek Supabase,
    // menghapus semuanya akan me-logout aplikasi lain yang kebetulan sealamat saat pengembangan.
    try {
      const ref = new URL(config.supabaseUrl).hostname.split('.')[0];
      if (ref) localStorage.removeItem(`sb-${ref}-auth-token`);
    } catch { /* URL tak wajar / mode privat */ }
  }
  return client;
}

/**
 * Escape input user untuk pola ILIKE di `.or()` PostgREST: bungkus "%...%" + escape `\` LALU `"`.
 * Koma/kurung/titik jadi literal di dalam kutip → tak bisa membuka klausa filter baru (anti-injeksi).
 * SATU sumber — dulu disalin di search.repo & sparepart.repo; kode keamanan tak boleh kembar (rawan drift).
 */
export const pat = (t: string): string => `"%${t.replace(/\\/g, '\\\\').replace(/"/g, '\\"')}%"`;
